import React, {useState, useEffect} from 'react';
import { compose, withHandlers, withState, withPropsOnChange, withProps } from 'recompose';
import {
  TableDataFetch
, withTable
, TableSearch
, TableCSVExport
, ReducedTableCSVExport
, withDateRange
, DateRange
, SortList
, JobTypeFilterList
, SearchFilterList
, InstallationPartnerFilterList
, WhiteLabelFilterList
, JobSubSubStatusFilter} from 'components/common/Tables';
import {
  Button,
  UncontrolledDropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  Pagination, Modal, ModalHeader, ModalBody
} from 'reactstrap';
import ReactPaginate from 'react-paginate'
import { Page, withResolver, NextPrevButtons, withDebug, LoadingSpinner } from 'components/common';
import { CSVImport, JobStatusTemplate, JobStatusUpdate } from 'components/common/JobStatusUpdate';
import { RADIUS_ADMIN, INSTALLER, RESELLER } from 'permissions';
import OrdersItem from './Item';
import { NotificationManager } from 'react-notifications';
import { updateIn } from 'icepick';
import moment from 'moment';
import { partition, keyBy, remove, map, find, range, get } from 'lodash';
import _ from "lodash";
import DatePicker from "react-datepicker";
import { SubJobStatusFilter } from './SubJobStatusFilter';
import FormGroup from '../../components/common/Forms/FormGroup';
import { Control } from 'react-redux-form';

const List = ({
  url = 'orders',
  canAssign = true,
  hideByDefault = false,
  showCompletedAt = false,
  showCreatedAt = true,
  showOrderStatus = true,
  ordering,
  data,
  setData,
  setPage,
  page,
  pages,
  limit,
  openItem,
  toggleCollapse,
  search,
  setSearch,
  setFilters,
  setTempFilters,
  filters,
  tempFilters,
  installers,
  partners,
  saveInstaller,
  saveEnabled,
  onInstallerChange,
  refresh,
  setRefresh,
  title,
  icon,
  jobIcon,
  filterUI,
  canManage,
  canView,
  client,
  role,
  fromDate,
  toDate,
  setFromDate,
  setToDate,
  searchTerm,
  setSearchTerm,
  jobStatuses,
  hasSearchBeenClicked,
  setHasSearchBeenClicked,
  isLoading,
  setIsLoading,
  onStatusChange,
  onBookedDateChange,
  toggleBookedDateModal,
  isBookedDateModalOpen,
  setIsBookedDateModalOpen,
  onCompletedDateChange,
  toggleCompletedDateModal,
  isCompletedDateModalOpen,
  setIsCompletedDateModalOpen,
  idx,
  jobIdx,
  appointment_date,
  job_completed_at,
  job_status,
  location,
  isSubStatus,
  jobSubStatusOptions,
  onJobSubStatusChange,
  setJobSubStatus,
  jobSubStatus,
  jobCompletedDate,
  jobSubStatuses,
  toggleSubStatusModal,
  isSubStatusModalOpen,
  setIsSubStatusModalOpen,
  jobSubStatusesFilter
}) => {

  useEffect(() => {
    console.log({filters});
    
    // If the user navigates away, this will clear sessionStorage
    if (!sessionStorage.getItem('location')) {
      sessionStorage.setItem('location', location.pathname);
    }

    if (location.pathname !== sessionStorage.getItem('location')) {
      sessionStorage.clear();
    }
  }, [ filters ])
  // Slightly hacky way to mantain search results when navigating back to the search from a job
  const storeFilters = (e) => {
    sessionStorage.removeItem((title + ' Filters'));
    sessionStorage.removeItem('searchTerm');
    sessionStorage.removeItem('onBack')
    sessionStorage.setItem((title + ' Filters'), JSON.stringify(tempFilters));
    sessionStorage.setItem('searchTerm', searchTerm);
  };
  
  const resetSearch = () => {
    setTempFilters({
      search_filter:'order_ref',
      jobtype_filter:999,
      ordering:'-imported_at'
    });
    setSearchTerm('');
  }

  const formatDate = (key, value) => {
    if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z$/.test(value)) {
      const date = new Date(value);
      return date;
    }
    return value;
  }

  useEffect(async () => {
    if (((sessionStorage.getItem((title + ' Filters'))) || (sessionStorage.getItem('searchTerm'))) && (sessionStorage.getItem('onBack') == "true")) {
      const storedFilters = sessionStorage.getItem((title + ' Filters'));
      const parsedFilters = JSON.parse(storedFilters, formatDate);
      if (sessionStorage.getItem((title + ' Filters'))) {
        await handleStoredFilters(parsedFilters);
      }
      const storedSearchTerm = sessionStorage.getItem('searchTerm');
      if (storedSearchTerm) {
        await storeFiltersTerm(storedSearchTerm);
      }
    setHasSearchBeenClicked(true);
    setIsLoading(true);
    }
    resetSearch();
    
  }, []);

  const handleStoredFilters = async (parsedFilters) => {
    setTempFilters(parsedFilters);
    setFilters(parsedFilters);
  }

  const storeFiltersTerm = async (storedSearchTerm) => {
    setSearch(storedSearchTerm);
  }
  
  return(
    <Page title={title}>
      {isBookedDateModalOpen && (
          <Modal isOpen={isBookedDateModalOpen} toggle={toggleBookedDateModal} keyboard={false} backdrop="static">
            <ModalHeader>
              Select Booked Date
            </ModalHeader>
            <ModalBody>
              <DatePicker
                  className="form-control"
                  value={appointment_date && moment(appointment_date).format('YYYY-MM-DD')}
                  onChange={v => onBookedDateChange(idx, jobIdx, v.format('YYYY-MM-DD'))}
                  dateFormat="YYYY-MM-DD"
                  required={job_status == "Installation Booked"}
              />
            </ModalBody>
          </Modal>
      )}
      {isCompletedDateModalOpen && (
          <Modal isOpen={isCompletedDateModalOpen} toggle={toggleCompletedDateModal} keyboard={false} backdrop="static">
            <ModalHeader>
              Select Completed Date
            </ModalHeader>
            <ModalBody>
              <DatePicker
                  className="form-control"
                  value={jobCompletedDate && moment(jobCompletedDate).format('YYYY-MM-DD')}
                  onChange={v => onCompletedDateChange(idx, jobIdx, v.format('YYYY-MM-DD'))}
                  dateFormat="YYYY-MM-DD"
                  required={job_status == "Installation Complete"}
              />
            </ModalBody>
            {isSubStatus && (
              <React.Fragment>
                <ModalHeader>
                  Select Job Status Detail
                </ModalHeader>
                <ModalBody>
                  <FormGroup model=".job_substatus">
                    <Control.select
                      model=".job_substatus"
                      onChange={onJobSubStatusChange}
                    >
                      <option value="" disabled selected hidden>
                        Select Job Status Detail
                      </option>
                      {jobSubStatusOptions.map(i => (
                        <option key={i.value} value={i.value}>
                          {i.text}
                        </option>
                      ))}
                    </Control.select>
                  </FormGroup>
                </ModalBody>
              </React.Fragment>
            )}
        </Modal>
      )}

      {isSubStatusModalOpen && (
          <Modal isOpen={isSubStatusModalOpen} toggle={toggleSubStatusModal} keyboard={false} backdrop="static">
            <ModalHeader>
              Select Job Status Detail
            </ModalHeader>
            <ModalBody>
            <FormGroup model=".job_substatus">
              <Control.select
                model=".job_substatus"
                onChange={onJobSubStatusChange}
            >
            <option value="" disabled selected hidden>
              Select Job Status Detail
            </option>
            {jobSubStatusOptions.map(i => (
              <option key={i.value} value={i.value}>
                {i.text}
              </option>
            ))}
          </Control.select>
            </FormGroup>
          </ModalBody>
          </Modal>
      )}

      <div className='d-flex justify-content-between align-items-stretch'>
        <SearchFilterList filters={tempFilters} setFilters={setTempFilters}/>
        <TableSearch onChange={
            (e) => {
              setSearchTerm(e);
              console.log("TableSearch changed.");
            }
          }
          onKeyUp={e => {
            e.preventDefault();
            if(e.keyCode === 13){
              console.log({tempFilters});
              setFilters(tempFilters);
              setSearch(searchTerm);
              setHasSearchBeenClicked(true);
              setIsLoading(true);
              storeFilters();
            }
          }}
          value={searchTerm}
        />

      {/*<button
          className="mb-4 mt-2 form-control-sm"
          style={{ "border":"1px solid #dee2e6", "backgroundColor":"#fff" }}
          onClick={() => {
            console.log({tempFilters});
            setFilters(tempFilters);
            setSearch(searchTerm);
            setHasSearchBeenClicked(true);
            setIsLoading(true);
          }}
        >Search</button>*/}

        <Button
          color="primary"
          className="mb-3 mt-2 px-4"
          onClick={() => {
            console.log({tempFilters});
            setRefresh(moment());
            setFilters(tempFilters);
            setSearch(searchTerm);
            setHasSearchBeenClicked(true);
            setIsLoading(true);
            storeFilters();
          }}
        >Search</Button>

      </div>
      <div className='d-flex flex-wrap justify-content-left'>
        {(title === "Unassigned Orders" || title === "Assigned Orders" || title === "All Orders" || title === "") &&
          <div className='mt-auto mb-auto mr-2'>
            {filterUI && filterUI.map(ui => ui({ tempFilters, setTempFilters }))}
          </div>
        }
        { (title === "Unassigned Orders" || title === "Assigned Orders" || title === "All Orders" || title === "") &&
          <div>
            <DateRange
              fromDate={fromDate}
              toDate={toDate}
              onFromDateChange={setFromDate}
              onToDateChange={setToDate}
              dateFormat={'YYYY-MM-DD'}
              filters={tempFilters}
              setFilters={setTempFilters}
            />
          </div>
        }
      { (title === "Assigned Orders" || title === "Completed Jobs" || title === "All Orders") &&
        <div className='mr-2'>
          <InstallationPartnerFilterList
            options={installers}
            filters={tempFilters}
            setFilters={setTempFilters}
          />
        </div>
      }
      <div className='mr-4'>
        <JobTypeFilterList filters={tempFilters} setFilters={setTempFilters}/>
      </div>
      {(role !== RESELLER) && (
      <div className='mr-4'>
        <WhiteLabelFilterList options={partners} filters={tempFilters} setFilters={setTempFilters}/>
      </div>
      )}
      <div className='mr-4'>
      { SubJobStatusFilter(title, tempFilters, setTempFilters) }
      </div>
      {(title === "Assigned Orders" || title === "Completed Jobs" || title === "All Orders") && (
      <div>
        <JobSubSubStatusFilter options={jobSubStatusesFilter} filters={tempFilters} setFilters={setTempFilters} />
      </div>
      )}
      { hideByDefault &&
        <div >
          <Button
            className=' btn-info'
            onClick={() =>{
              setFilters({
                ...tempFilters,
                search_filter: 'order_ref',
                offset: 0,
              });
              setSearch(' ')
          }}>
            Show
          </Button>
        </div>
      }
      <div className='mr-auto p-2'/>
      </div>
      {(!hideByDefault || search) &&
      <div>
      { data.count != 0 &&
          <ReactPaginate
            pageCount={data.count / limit}
            forcePage={page}
            marginPagesDisplayed={2}
            pageRangeDisplayed={15}
            breakClassName="page-item"
            breakLabel={<a className="page-link">...</a>}
            pageClassName="page-item"
            previousClassName="page-item"
            nextClassName="page-item"
            pageLinkClassName="page-link"
            previousLinkClassName="page-link"
            nextLinkClassName="page-link"
            nextLabel={'next'}
            previousLabel={'previous'}
            breaklabel={'...'}
            containerClassName={'pagination no-margin pull-right mb-0'}
            subContainerClassName={'page-item pagination no-margin pull-right mb-0'}
            activeClassName={'active'}
            onPageChange={({selected}) => {
              window.scroll(0,0);
              setPage(selected);
              setFilters({
                ...tempFilters,
                offset: selected <= 0 ? 0 : (selected) * limit,
              });
            }}
          />
        }
        <br/><br/>

        {!!isLoading && (
          <LoadingSpinner/>
        )}

        {data && data.results.map((x, idx) => (
          <OrdersItem
            key={x.id}
            item={x}
            open={openItem === x.id}
            client={client}
            refresh={refresh}
            setRefresh={setRefresh}
            toggleCollapse={toggleCollapse}
            installers={installers}
            saveInstaller={saveInstaller}
            saveEnabled={saveEnabled}
            onInstallerChange={onInstallerChange}
            canAssign={canAssign}
            showCompletedAt={showCompletedAt}
            showCreatedAt={showCreatedAt}
            showOrderStatus={showOrderStatus}
            canManage={canManage}
            canView={canView}
            icon={icon}
            jobIcon={jobIcon}
            statuses={jobStatuses}
            substatuses={jobSubStatuses}
            canChangeStatus={role === RESELLER ? false : true}
            onStatusChange={(jobIdx, value) => onStatusChange(idx, jobIdx, value)}
            onBookedDateChange={(jobIdx, value) => onBookedDateChange(idx, jobIdx, value)}
            toggleBookedDateModal={toggleBookedDateModal}
            isBookedDateModalOpen={isBookedDateModalOpen}
            setIsBookedDateModalOpen={setIsBookedDateModalOpen}
            onCompletedDateChange={(jobIdx, value) => onCompletedDateChange(idx, jobIdx, value)}
            toggleCompletedDateModal={toggleCompletedDateModal}
            isCompletedDateModalOpen={isCompletedDateModalOpen}
            setIsCompletedDateModalOpen={setIsCompletedDateModalOpen}
            toggleSubStatusModal={toggleSubStatusModal}
            isSubStatusModalOpen={isSubStatusModalOpen}
            setIsSubStatusModalOpen={setIsSubStatusModalOpen}
          />
        ))}
        { data.count != 0 &&
          <ReactPaginate
            pageCount={data.count / limit}
            forcePage={page}
            marginPagesDisplayed={2}
            pageRangeDisplayed={15}
            breakClassName="page-item"
            breakLabel={<a className="page-link">...</a>}
            pageClassName="page-item"
            previousClassName="page-item"
            nextClassName="page-item"
            pageLinkClassName="page-link"
            previousLinkClassName="page-link"
            nextLinkClassName="page-link"
            nextLabel={'next'}
            previousLabel={'previous'}
            breaklabel={'...'}
            containerClassName={'pagination no-margin pull-right mb-0'}
            subContainerClassName={'page-item pagination no-margin pull-right mb-0'}
            activeClassName={'active'}
            onPageChange={({selected}) => {
              window.scroll(0,0);
              setPage(selected);
              setFilters({
                ...tempFilters,
                offset: selected <= 0 ? 0 : (selected) * limit,
              });
            }}
          />
        }
      </div>}
      {(role === RADIUS_ADMIN || role === INSTALLER) && (
        (title !== "All Orders") &&
        <div>
          <br/><br/>
          <TableCSVExport
            ordering={ordering}
            refreshToken={refresh}
            limit={999999}
            filters={filters}
            url={url}
            search={search}
            filename={date => `orders_${date}.csv`}
            client={client}
            offset={0}
          />
          <ReducedTableCSVExport
            ordering={ordering}
            refreshToken={refresh}
            limit={999999}
            filters={filters}
            url={url}
            search={search}
            filename={date => `orders_${date}.csv`}
            client={client}
            offset={0}
          />
        <CSVImport
            client={client}
            setRefresh={setRefresh}
            setIsLoading={setIsLoading}
            setHasSearchBeenClicked={setHasSearchBeenClicked}
            subStatuses={jobSubStatuses}
        />
        <JobStatusTemplate
            ordering="jobs.id"
            refreshToken={refresh}
            limit={999999}
            filters={filters}
            url={url}
            search={search}
            filename="jobstatuses.csv"
            client={client}
            offset={0}
        />
        </div>
      )}
      {!!hasSearchBeenClicked && (
        <TableDataFetch
          ordering={ordering}
          refreshToken={refresh}
          limit={limit}
          filters={filters}
          url={url}
          search={search}
          onDataFetched={setData}
          onLoaded={setIsLoading}
        />
      )}
    </Page>
  )
}

const enhance = compose(
  withTable({ limit: 25 }),
  withState('idx', 'setIdx', null),
  withState('jobIdx', 'setJobIdx', null),
  withState('job_status', 'setJobStatus', null),
  withState('openItem', 'setOpenItem', null),
  withState('installers', 'setInstallers', []),
  withState('partners', 'setPartners', []),
  withState('saveEnabled', 'setSaveEnabled', false),
  withState('refresh', 'setRefresh', "this is here to force stuff to change"),
  withState('filters', 'setFilters', {
    search_filter:'order_ref',
    jobtype_filter:999,
    ordering:'-imported_at'
  }),
  withState('tempFilters', 'setTempFilters', {
    search_filter:'order_ref',
    jobtype_filter:999,
    ordering:'-imported_at'
  }),
  withState('searchTerm', 'setSearchTerm', ''),
  withState('isLoading', 'setIsLoading', false),
  withState('hasSearchBeenClicked', 'setHasSearchBeenClicked', false),
  withState('jobStatuses', 'setJobStatuses', null),
  withState('jobSubStatuses', 'setJobSubStatuses', null),
  withState('jobSubStatusOptions', 'setJobSubStatusOptions', []),
  withState('isSubStatus', 'setIsSubStatus', false),
  withState('jobSubStatus', 'setJobSubStatus', null),
  withState('jobSubStatusesFilter', 'setJobSubStatusesFilter', []),
  withState('jobCompletedDate', 'setJobCompletedDate', null),
  withDateRange(),
  withState('page', 'setPage', 0),
  withPropsOnChange(['data', 'limit'], ({data, limit}) => {
    return {data, limit, pages: range(1, Math.ceil(data.count / limit) + 1)}
  }),
  withResolver(
    {
      partners: () => client => client.get('white-label-partners')
    },
    {
      onResolved: ({ setPartners }) => ({ partners }) => {
        setPartners(partners);
      },
    }
  ),
  withResolver(
    {
      installers: () => client => client.get('installers')
    },
    {
      onResolved: ({ setInstallers }) => ({ installers }) => {
        setInstallers(installers);
      },
    }
  ),
  withResolver(
    {
      jobStatuses: () => client => client.get('job_statuses_filters'),
      jobSubStatus: () => client => client.get('job_substatuses'),
    },
    {
      onResolved: ({ setJobStatuses, setJobSubStatuses }) => ({ jobStatuses, jobStatusesAll, jobSubStatus }) => {
        setJobStatuses(jobStatuses);
        setJobSubStatuses(jobSubStatus);
      },
    }
  ),
  withDebug('jobStatuses'),
  withHandlers({
    updateItem: ({ data, updateResults }) => (idx, path, cb) => {
      updateResults(updateIn(data.results, [idx, ...path], cb));
    },
  }),
    withState('isBookedDateModalOpen','setIsBookedDateModalOpen',false),
    withState('isCompletedDateModalOpen','setIsCompletedDateModalOpen',false),
    withState('isSubStatusModalOpen','setIsSubStatusModalOpen',false),
    withState('appointment_date','setAppointmentDate',false),
    withState('job_completed_at','setJobCompletedAt',false),
  withHandlers({
    toggleBookedDateModal: ({isBookedDateModalOpen, setIsBookedDateModalOpen}) => () => {
      setIsBookedDateModalOpen(!isBookedDateModalOpen);
    },
  }),
  withHandlers({
    toggleCompletedDateModal: ({isCompletedDateModalOpen, setIsCompletedDateModalOpen}) => () => {
      setIsCompletedDateModalOpen(!isCompletedDateModalOpen);
    },
  }),
  withHandlers({
    toggleSubStatusModal: ({isSubStatusModalOpen, setIsSubStatusModalOpen}) => () => {
      setIsSubStatusModalOpen(!isSubStatusModalOpen);
    },
  }),
  withHandlers({
    onBookedDateChange: ({ client, data, updateItem, setIsBookedDateModalOpen }) => (
      idx,
      jobIdx,
      appointment_date
    ) => {
      const order = data.results[idx];
      const job = order.jobs[jobIdx];

      client.patch(`installer-jobs/${job.id}`, { appointment_date }).tap(() => {
        updateItem(idx, ['jobs', jobIdx, 'appointment_date'], () => appointment_date);
        NotificationManager.success('Appointment date updated');
      });
      setIsBookedDateModalOpen(false);
    },
  }),
  withHandlers({
    onCompletedDateChange: ({ 
      setJobCompletedAt,
      client, 
      data, 
      updateItem, 
      setIsCompletedDateModalOpen, 
      isSubStatus, 
      jobSubStatus,
      setJobSubStatus,
      setJobCompletedDate,
    }) =>(
      idx,
      jobIdx,
      job_completed_at
    ) => {
      setJobCompletedDate(job_completed_at);

      if (!isSubStatus || (isSubStatus && jobSubStatus) && job_completed_at) {
        const order = data.results[idx];
        const job = order.jobs[jobIdx];

      client.patch(`installer-jobs/${job.id}`, { job_completed_at, ...(isSubStatus ? { job_substatus: jobSubStatus} : {}) }).tap(() => {
        updateItem(idx, ['jobs', jobIdx, 'job_completed_at'], () => job_completed_at);
        if(isSubStatus) {
          updateItem(idx, ['jobs', jobIdx, 'job_substatus'], () => jobSubStatus);
          NotificationManager.success('Completed date and substatus updated');
        } else {
          NotificationManager.success('Completed date updated');
        }
      });
      setIsCompletedDateModalOpen(false);
      setJobSubStatus(null);
      setJobCompletedDate(null);
    }
    }
  }),
  withHandlers({
    onStatusChange: ({ 
      client, 
      data, 
      updateItem, 
      toggleBookedDateModal, 
      toggleCompletedDateModal, 
      toggleSubStatusModal,
      setJobStatus, 
      setIdx, 
      setJobIdx, 
      setAppointmentDate, 
      setJobCompletedAt, 
      setIsSubStatus, 
      jobSubStatuses, 
      setJobSubStatusOptions,
      isSubStatus
    }) => (
      idx,
      jobIdx,
      job_status
    ) => {
      const order = data.results[idx];
      const job = order.jobs[jobIdx];
      let showSubStatusModel = false;

      setJobStatus(job_status);
      setIdx(idx);
      setJobIdx(jobIdx);
      setAppointmentDate(job.appointment_date);
      setJobCompletedAt(job.job_completed_at);

      if ([26, 42, 50, 51, 52, 80].includes(job_status)) {
        showSubStatusModel = true;
        setIsSubStatus(true);
        const subStatuses = _.get(_.find(jobSubStatuses, (obj) => obj.type.value == job_status), 'subStatuses', []);
        setJobSubStatusOptions(subStatuses);
      } else {
        setIsSubStatus(false);
      }

      if ([40, 41, 76, 78].includes(job_status)) {
        toggleBookedDateModal();
      } else if (job_status < 50 && showSubStatusModel) {
        toggleSubStatusModal();
      }

      if ([50, 51, 52, 70, 71, 77, 79, 80].includes(job_status)) {
        toggleCompletedDateModal();
      }

      client.patch(`installer-jobs/${job.id}`, { job_status }).tap(() => {
        updateItem(idx, ['jobs', jobIdx, 'job_status'], () => job_status);
        NotificationManager.success('Status updated');
      });
    },
    toggleCollapse: ({ openItem, setOpenItem, setSaveEnabled }) => item => {
      if (openItem === item) setOpenItem(null);
      else setOpenItem(item);
      setSaveEnabled(false);
    },
  }),
  withHandlers({
    onJobSubStatusChange: ({ 
      setJobCompletedDate,
      setJobSubStatus,
      jobCompletedDate,
      setIsCompletedDateModalOpen,
      client,
      updateItem,
      data,
      idx,
      jobIdx,
      isSubStatus,
      setIsSubStatusModalOpen,
      isCompletedDateModalOpen
    }) => (event) => {
      const order = data.results[idx];
      const job = order.jobs[jobIdx];
      const {value} = event.target;
      setJobSubStatus(value)
      if(isSubStatus && value && isCompletedDateModalOpen && jobCompletedDate) {

        client.patch(`installer-jobs/${job.id}`, { 
          job_completed_at: jobCompletedDate,
          job_substatus: value,
        }).tap(() => {
          updateItem(idx, ['jobs', jobIdx, 'job_completed_at'], () => jobCompletedDate);
          updateItem(idx, ['jobs', jobIdx, 'job_substatus'], () => value);
          NotificationManager.success('Completed date and substatus updated');
        });
        setIsCompletedDateModalOpen(false);
        setJobSubStatus(null);
        setJobCompletedDate(null);
      } else if (isSubStatus && value && !isCompletedDateModalOpen) {
        client.patch(`installer-jobs/${job.id}`, { 
          job_substatus: value,
        }).tap(() => {
          updateItem(idx, ['jobs', jobIdx, 'job_substatus'], () => value);
          NotificationManager.success('Substatus updated');
        });
        setIsSubStatusModalOpen(false);
        setJobSubStatus(null);
      }
    },
  }),
  withPropsOnChange(['tempFilters'], ({ tempFilters, setJobSubStatusesFilter, jobSubStatuses }) => {
      const statusFilter = Object.keys(tempFilters).filter(key => key.startsWith('status'));
      const statuses = statusFilter.map(key => tempFilters[key]);
      const subStatuses = jobSubStatuses.filter(i => statuses.includes(i.type.value)).map(i => i.subStatuses).flat();
      setJobSubStatusesFilter(subStatuses);
  }),
);

export default enhance(List);


// WEBPACK FOOTER //
// ./src/pages/Orders/List.jsx